import React, { useState, useEffect, Fragment } from "react";
import { Button, Table, UncontrolledDropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap";
import { CircularProgress } from "../..";
import InfiniteScroll from "react-infinite-scroller";
import style from "./styles.module.scss";
import ModalStatus from "../Modals/ModalStatus";
import ModalClone from "../Modals/ModalClone";
import { Status } from "../Controls";
import { AssetStatus } from "../types";
import HistoryDefault from "../../Modal/HistoryDefault/HistoryDefault";
import { FormattedDate } from "react-intl";

const Grid = ({ grid, getAssets, getHistory, clone, Link, changeStatus, role, getContractcLosingLeg, isFundManager, fundInstalled, exportAsset, TraderCanCreateAssets }) => {
  const [modalStatus, setModalStatus] = useState(false);
  const [modalClone, setModalClone] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);

  const handleAction = (action, { id, item }) => {
    if (action == "delete") {
      changeStatus({ assetId: id, nextStatus: AssetStatus.Deleted });
    } else if (action == "clone") {
      setModalClone({ item });
    } else if (action == "status") {
      setModalStatus({ item });
    } else if (action == "history") {
      setModalHistory({ process: "Asset", processId: id });
    } else if (action == "exportToFunds") {
      exportAsset({id});
    }
  };

  return (
    <div className={style.grid}>
      <InfiniteScroll
        pageStart={0}
        loader={
          <div className="loader" key={0}>
            <CircularProgress sm />
          </div>
        }
        loadMore={getAssets}
        hasMore={grid.hasMore}
      >
        <Table striped hover>
          <thead>
            <tr>
              <th>Ticker</th>
              <th>Name</th>
              <th>ISIN/Cusip</th>
              <th>Status</th>
              <th>Active Date</th>
              <th>Modified Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {grid.assets == null || grid.assets.length == 0 ? (
              <EmptyTable loading={grid.assets == null} />
            ) : (
              grid.assets.map((asset) => (
                <tr key={`asset-${asset.AssetId}`}>
                  <td>
                    <Link to={`/asset/${asset.AssetId}`}>
                      <span className="mr-2">#{asset.AssetId}</span>
                      {asset.AssetTicker}
                    </Link>
                  </td>
                  <td>
                    <Link to={`/asset/${asset.AssetId}`}>{asset.AssetName}</Link>
                  </td>
                  <td>{asset.AssetISIN}</td>
                  <td>
                    <Status status={asset.AssetStatus} />
                  </td>
                  <td>
                    {asset.AssetStatus == AssetStatus.Active && (
                      <FormattedDate value={asset.AssetActiveDateTime} />
                    )}
                  </td>
                  <td>
                    <FormattedDateWithEmpty value={asset.AssetModifiedDateTime} />
                  </td>
                  <td>
                    <div className={style.actions}>
                      <Button
                        outline
                        color="primary"
                        size="sm"
                        key={`history-${asset.AssetId}`}
                        onClick={() => handleAction("history", { id: asset.AssetId })}
                        className={style.iconBtn}
                      >
                        <i className="fa fa-history"></i>
                      </Button>

                      {(role !== "advisor" && (role !== "trader" || (role === "trader" && TraderCanCreateAssets)))&& (
                        <UncontrolledDropdown>
                          <DropdownToggle
                            color="link"
                            size="sm"
                            className={style.dropdown}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <i className="icon-options-vertical icons d-block" />
                          </DropdownToggle>

                          <DropdownMenu>
                            {role == "backoffice" && (
                              <DropdownItem onClick={() => handleAction("status", { item: asset })}>
                                Change status
                              </DropdownItem>
                            )}
                            {(role == "backoffice" || role === "trader") && fundInstalled && !isFundManager && (
                              <DropdownItem onClick={() => handleAction("exportToFunds", { id: asset.AssetId })}>
                                Export to Funds
                              </DropdownItem>
                            )}
                            {(role == "backoffice" || role === "trader") && (
                              <DropdownItem onClick={() => handleAction("clone", { item: asset })}>
                                Clone
                              </DropdownItem>
                            )}
                            {role == "backoffice" && (
                              <DropdownItem onClick={() => handleAction("delete", { id: asset.AssetId })}>
                                Delete
                              </DropdownItem>
                            )}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </InfiniteScroll>

      {modalStatus && (
        <ModalStatus
          open={true}
          {...modalStatus}
          getContractcLosingLeg={getContractcLosingLeg}
          changeStatus={changeStatus}
          toggle={() => setModalStatus(false)}
        />
      )}
      {modalClone && (
        <ModalClone open={true} {...modalClone} clone={clone} toggle={() => setModalClone(false)} />
      )}
      {modalHistory && (
        <HistoryDefault
          open={true}
          {...modalHistory}
          onHistoryRequest={getHistory}
          onToggle={() => setModalHistory(false)}
        />
      )}
    </div>
  );
};

const EmptyTable = ({ loading }) => (
  <tr className={style.empty}>
    <td colSpan="7" style={{ textAlign: "center", padding: "60px" }}>
      {loading ? <CircularProgress style={{ marginTop: "10%" }} /> : <h4>No assets</h4>}
    </td>
  </tr>
);

const FormattedDateWithEmpty = ({ value }) =>
  value == "0000-00-00T00:00:00" || value === null ? null : <FormattedDate value={value} />;

export default Grid;